import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';


@Injectable({
	providedIn: 'root'
})
export class AuthGuard  {
	protected router = inject(Router);
	protected auth = inject(AuthService);


	async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

		if (this.auth.authenticated /*&& this.auth.hasCFSession()*/) {
			return true;
		} else {
			try {
				await this.auth.reAuthenticate();
				if(this.auth.user /*&& this.auth.hasCFSession()*/){
					return true;
				}else {
					this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
					return false;
				}
			} catch(err){
				this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
				return false;
			}
		}
	}
}